module.exports = __webpack_public_path__ + "img/localData.d066a23e.png";